(ns teamoesterreich.admin-mode.modal.send-message-modal
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.admin-mode.data.text-block :as d-text-block]
            [teamoesterreich.admin-mode.data.organisation :as d-org]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.send-two-tone :refer [send-two-tone]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.util.log :as log]))

(defn get-templates [template-group]
  (when (not (and (get-in @v-state/app-state [:text-blocks (keyword template-group)])
                  (coll? (get-in @v-state/app-state [:text-blocks (keyword template-group)]))))
    (d-text-block/get-group-text-blocks template-group
                                        (fn [res]
                                          (let [res (reduce (fn [c [r e]]
                                                              ;(log/debug "check template " (clj->js e))
                                                              (if (and
                                                                    (or (nil? (:toeTextBlock-key e)) (= "" (:toeTextBlock-key e)))
                                                                    (not (false? (:toeTextBlock-active e))))
                                                                (assoc c
                                                                  r e)
                                                                c))
                                                            {}
                                                            res)]

                                            (swap! v-state/app-state assoc-in [:text-blocks (keyword template-group)] res))))))


(defn email-template-modal [!show template-group message ok-message on-send-fn & [on-cancel-fn on-send-self-fn]]
  (let [!st (r/atom {:subject "" :body "" :template "" :template-set false :invalidate 0})
        !template (r/cursor !st [:template])
        !templates (r/cursor v-state/app-state [:text-blocks (keyword template-group)])
        !org (r/cursor v-state/app-state [:organisations])
        !me (r/cursor v-state/app-state [:me])
        !template-set (r/cursor !st [:template-set])
        !subject (r/cursor !st [:subject])
        !body (r/cursor !st [:body])
        !reply (r/cursor !st [:reply])
        !invalidate (r/cursor !st [:invalidate])

        ]
    (fn []
      (get-templates template-group)

      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show false)

        }
       [:div
        {
         :class "modal"
         :style {:width 800}}
        [mui/grid {:container  true
                   :direction  "row"
                   :error      (< (count (str (:userDocument-type @!st))) 1)
                   :justify    "space-between"
                   :spacing    2
                   :style      {:paddingRight "5px"}
                   :alignItems "flex-start"}
         [mui/grid {:container false :item true :xs 12}
          [:h4 message]
          ]

         (when (and template-group (coll? @!templates))
           [mui/grid {:container false :item true :xs 8}
            [mui/input-label {:style {:font-size "12px"}} "Vorlage "]
            [mui/select
             {:fullWidth true
              :value     (or @!template "")
              :onChange  (fn [e]
                           (let [v (h/event-value e)]
                             (swap! !st assoc
                                    :template v
                                    :template-set (if (= "" v) false true))))
              }
             (for [[k v] (filter (fn [[k v]] (= (:toeTextBlock-type v) "email")) @!templates)]
               ^{:key (str "template-" k)}
               [mui/menu-item {:style {} :value k} (str (:toeTextBlock-name v))])
             ]
            ])

         (let [reply-list (d-org/get-reply-address-list @!me @!org)]
           (when (and reply-list (coll? @!templates))
             [mui/grid {:container false :item true :xs 8}
              [mui/input-label {:style {:font-size "12px"}} "Antwortadresse " (d-org/get-prefered-reply-address-list @!me @!org template-group)]
              [mui/select
               {:fullWidth true
                :value     (or @!reply (d-org/get-prefered-reply-address-list @!me @!org template-group))
                :onChange  (fn [e]
                             (let [v (h/event-value e)]
                               (swap! !st assoc
                                      :reply v)))
                }
               (for [reply reply-list]
                 ^{:key (str "template-" reply)}
                 [mui/menu-item {:style {} :value reply} (str reply)])
               ]
              ])
           )


         (when (and template-group (coll? @!templates))
           (when template-group
             [mui/grid {:container false :item true :xs 4}
              [mui/button
               {:style     {:float "right"}
                :color     "secondary"
                :variant   "contained"
                :title     "Vorlage verwenden"
                :disabled  (not @!template-set)
                :startIcon (r/as-element [done])
                :onClick   (fn []
                             (let [tmpl (get @!templates @!template)]
                               (swap! !st assoc
                                      :body (:toeTextBlock-content tmpl)
                                      :subject (:toeTextBlock-subject tmpl)
                                      :invalidate (rand-int 100)
                                      :template-set false)
                               ))
                }
               "verwenden"]]))

         [mui/grid {:container false :item true :xs 12}

          [mui/text-field
           {:onChange        (fn [e] (reset! !subject (h/event-value e)))
            :value           @!subject
            :fullWidth       true
            :InputLabelProps {:disableAnimation true :shrink true}
            :label           "Betreff"
            :multiline       false
            }]]


         [mui/grid {:container false :item true :xs 12}
          [edit-md-card/get-it-small !body @!invalidate]
          ]



         [mui/grid {:container false :item true :xs 6}
          [mui/button
           {
            :variant   "contained"
            :startIcon (r/as-element [keyboard-arrow-left])
            :style     {:marginRight 50}
            :onClick   (fn []
                         (if on-cancel-fn
                           (on-cancel-fn)
                           (reset! !show false)))
            }
           "Abbrechen"]
          ]
         [mui/grid {:container false :item true :xs 6}

          [mui/button
           {:style     {:float "right"}
            :color     "secondary"
            :variant   "contained"
            :disabled  (or (< (count @!body) 1) (< (count @!subject) 1))
            :startIcon (r/as-element [send-two-tone])
            :onClick   (fn []
                         (on-send-fn @!subject
                                     @!body
                                     (or @!reply (d-org/get-prefered-reply-address-list @!me @!org template-group)))
                         (reset! !show false))
            }
           ok-message]
          (when on-send-self-fn [mui/button
                                 {:style     {:float "right" :marginRight "7px"}
                                  :variant   "contained"
                                  :disabled  (or (< (count @!body) 1) (< (count @!subject) 1))
                                  :startIcon (r/as-element [send-two-tone])
                                  :onClick   (fn []
                                               (on-send-self-fn @!subject
                                                                @!body
                                                                (or @!reply (d-org/get-prefered-reply-address-list @!me @!org template-group)))
                                               (reset! !show false))
                                  }
                                 "test mir senden"])

          ]
         ]
        ]
       ]
      )))


(defn email-modal [!show message ok-message on-send-fn & [on-cancel-fn]]
  (email-template-modal !show nil message ok-message on-send-fn on-cancel-fn))

(defn sms-modal [!show message ok-message on-send-fn & [on-cancel-fn]]
  (let [!st (r/atom {:body ""})
        !body (r/cursor !st [:body])]
    (fn []
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show nil)

        }
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h4 message]



        [mui/text-field
         {:onChange        (fn [e] (reset! !body (h/event-value e)))
          :fullWidth       true
          :InputLabelProps {:disableAnimation true :shrink true}
          :label           "Betreff"
          :multiline       true
          :helperText      (if (> (count @!body) 160)
                             (str "Sms-Text Länge (" (count @!body) ") länger als 160 Zeichen!")
                             (str "Sms-Text Länge max: 160 Zeichen (dzt:" (count @!body) ")"))
          :rows            3
          }]

        [:br]
        [:br]
        [mui/button
         {:variant   "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style     {:marginRight 50}
          :onClick   (fn []
                       (if on-cancel-fn
                         (on-cancel-fn)
                         (reset! !show nil)))
          }
         "Abbrechen"]
        [mui/button
         {:color     "secondary"
          :style     {:float "right"}
          :variant   "contained"
          :disabled  (< (count @!body) 1)
          :startIcon (r/as-element [send-two-tone])
          :onClick   (fn []
                       (on-send-fn @!body)
                       (reset! !show nil))
          }
         ok-message]]
       ]
      )))

(defn push-modal [!show message ok-message on-send-fn & [on-cancel-fn]]
  (let [!st (r/atom {:body ""})
        !body (r/cursor !st [:body])]
    (fn []
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show nil)

        }
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h4 message]



        [mui/text-field
         {:onChange        (fn [e] (reset! !body (h/event-value e)))
          :fullWidth       true
          :InputLabelProps {:disableAnimation true :shrink true}
          :label           "Betreff"
          :multiline       true
          :helperText      (if (> (count @!body) 160)
                             (str "Push-Text Länge (" (count @!body) ") länger als 160 Zeichen!")
                             (str "Push-Text Länge max: 160 Zeichen (dzt:" (count @!body) ")"))
          :rows            3
          }]

        [:br]
        [:br]
        [mui/button
         {:variant   "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style     {:marginRight 50}
          :onClick   (fn []
                       (if on-cancel-fn
                         (on-cancel-fn)
                         (reset! !show nil)))
          }
         "Abbrechen"]
        [mui/button
         {:color     "secondary"
          :style     {:float "right"}
          :variant   "contained"
          :disabled  (< (count @!body) 1)
          :startIcon (r/as-element [send-two-tone])
          :onClick   (fn []
                       (on-send-fn @!body)
                       (reset! !show nil))
          }
         ok-message]]
       ]
      )))
